import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    CellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    AccountExtra2: {
      validations: []
    },
    Reference: {
      validations: []
    },
    PartyName: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    EventExtra4: {
      validations: []
    },
    Category: {
      validations: []
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    EventExtra3: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'GUEST OF HONOR NAME(S):',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'ADDRESS:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'CITY:',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'ZIP:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE:',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'CELL:',
            mapping: 'CellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL:',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'REQUESTED DATE OF FUNCTION:',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'radio-buttons',
            size: 'Medium',
            label: 'AFTERNOON/EVENING',
            options: [
              {label: 'Afternoon' , value: 'Afternoon'},
              {label: 'Evening' , value: 'Evening'}
            ],
            mapping: 'AccountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'HOW DID YOU HEAR ABOUT US?:',
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'TYPE OF FUNCTION:',
            options: [
              {label: 'Wedding' , value: 'Wedding'},
              {label: 'Holiday Party' , value: 'Holiday Party'},
              {label: 'Mitzvah/Quinceaneras/Sweet Sixteen' , value: 'Mitzvah/Quinceaneras/Sweet Sixteen'},
              {label: 'Birthday/Anniversary' , value: 'Birthday/Anniversary'},
              {label: 'Communion/Confirmation' , value: 'Communion/Confirmation'},
              {label: 'Graduation' , value: 'Graduation'},
              {label: 'Corporate Party/Dinner/Luncheon' , value: 'Corporate Party/Dinner/Luncheon'},
              {label: 'Corporate Event/Trade Show/Seminar' , value: 'Corporate Event/Trade Show/Seminar'},
              {label: 'Team Building' , value: 'Team Building'},
            ],
            mapping: 'PartyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'EXPECTED AMOUNT OF GUESTS:',
            options: [
              {label: '50-75' , value: '50-75'},
              {label: '75-100' , value: '75-100'},
              {label: '100-150' , value: '100-150'},
              {label: '150-200' , value: '150-200'},
              {label: '200-250' , value: '200-250'},
              {label: '250+' , value: '250+'},
            ],
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'SUITE:',
            mapping: 'EventExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'CEREMONY:',
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PRICE PER PERSON:',
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'MINIMUM NUMBER OF PERSONS:',
            mapping: 'EventExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'SPECIAL PREFERENCES:',
            mapping: 'EventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Terrace On The Park Contact Form',
    formId: '632',
    clientKey: '8FFCA8F1-946A-401A-BD09-93DB476ED67D',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/terraceonthepark/form_structure.js